import { render } from "./LoadingControl.vue?vue&type=template&id=bcc718f6&scoped=true"
import script from "./LoadingControl.vue?vue&type=script&lang=js"
export * from "./LoadingControl.vue?vue&type=script&lang=js"

import "./LoadingControl.vue?vue&type=style&index=0&id=bcc718f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\Bod_registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc718f6"]])

export default __exports__